import { DASHBOARD_ACCENT } from './dashboardSurfaceSx';
import {
  getDashboardWorkspaceAvatarSx as getPendingTaskAvatarSx,
  getDashboardWorkspaceBadgeSx as getPendingTaskBadgeSx,
  getDashboardWorkspaceCardSx as getPendingTasksPanelSx,
  getDashboardWorkspaceHeaderSx as getPendingTasksHeaderSx,
  getDashboardWorkspaceItemMetaSx as getPendingTaskMetaSx,
  getDashboardWorkspaceRowSx as getPendingTaskRowSx,
  getDashboardWorkspaceItemTitleSx as getPendingTaskTitleSx,
  getDashboardWorkspaceScrollSx as getPendingTasksScrollSx,
  getDashboardWorkspaceSectionHeaderSx as getPendingTasksSectionHeaderSx,
  getDashboardWorkspaceSectionTitleSx as getPendingTasksSectionTitleSx,
  getDashboardWorkspaceSubtitleSx as getPendingTasksSubtitleSx,
  getDashboardWorkspaceSummaryChipSx as getPendingTasksSummaryChipSx,
  getDashboardWorkspaceTitleSx as getPendingTasksTitleSx,
} from './dashboardWorkspaceLayout';

export const TASK_SECTION_META = {
  no_show_ota: { color: '#a78bfa', emoji: 'ota' },
  web_checkin: { color: '#12b886', emoji: 'wci' },
  checkin: { color: '#60a5fa', emoji: 'in' },
  payment: { color: '#f59e0b', emoji: 'pay' },
  checkout: { color: '#4ce1b6', emoji: 'out' },
  housekeeping: { color: '#fb7185', emoji: 'hk' },
};

export {
  getPendingTaskAvatarSx,
  getPendingTaskBadgeSx,
  getPendingTaskMetaSx,
  getPendingTaskRowSx,
  getPendingTaskTitleSx,
  getPendingTasksHeaderSx,
  getPendingTasksPanelSx,
  getPendingTasksScrollSx,
  getPendingTasksSectionHeaderSx,
  getPendingTasksSectionTitleSx,
  getPendingTasksSubtitleSx,
  getPendingTasksSummaryChipSx,
  getPendingTasksTitleSx,
  DASHBOARD_ACCENT,
};
